import React, {ReactNode} from 'react'

type ContextProviderProps = {
    providers: React.FC[]
    children: ReactNode
}

const ContextProvider: React.FC<ContextProviderProps> = (props) => {
    return props.providers.reduceRight((acc, Provider) => {
        return <Provider>{acc}</Provider>
    }, <React.Fragment>{props.children}</React.Fragment>)
}

export default ContextProvider
